import script from "./EngineerRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./EngineerRegister.vue?vue&type=script&setup=true&lang=js"

import "./EngineerRegister.vue?vue&type=style&index=0&id=adee60e4&lang=scss"

const __exports__ = script;

export default __exports__